import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { AuthorizeService } from '../services/authorize.service';

@Injectable()
export class AuthorizeGuard {
  constructor(private _authorizeService: AuthorizeService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._authorizeService.isDoneLoading$.pipe(
      filter(isDone => isDone),
      switchMap(_ => this._authorizeService.isAuthenticated$),
      tap(isAuthenticated => {
        isAuthenticated || this._authorizeService.login(state.url, true);
      })
    );
  }
}
